import { apolloClient } from "@td/ui";
import FETCH_CONSULTATION_QUERY from "../queries/fetch-consultation-for-pre-intake.graphql";

export const fetchConsultation = async (consultationId) => {
  const { data: { consultation: data } } = await apolloClient.query({
    fetchPolicy: "network-only",
    query: FETCH_CONSULTATION_QUERY,
    variables: {
      consultationId,
    },
  });

  return data;
};
